const domain = 'https://saoma1.wousdt.cc/';  //你的域名
export default {
  publicUrl:domain
}